import { render, staticRenderFns } from "./4.vue?vue&type=template&id=40cef7be&scoped=true"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=40cef7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cef7be",
  null
  
)

export default component.exports